import { frequency } from '../../components/Navbar/SavedHomeSearch/FrequencySelectInput';
import { UserFilters, UserLocation } from '../../interfaces/interfaces';
import { userFilterDefaults } from '../../utilities/stateUtils';
import { savedSearchApiUrl } from '@capcenter/shared';
import { fetchWithAuth } from '../AuthHelper';
import createQuery from '../search/elasticQueryBuilder';

const getValidFilterItemsAndConvertToSearchFormat = (filters: UserFilters) => {
	const searchFilters: object[] = [];
	Object.keys(filters).forEach(filterKey => {
		if (filterKey === 'initialized') return;

		const filterType = filterKey;
		const filterValue = filters[filterKey as keyof UserFilters];

		if (filterValue === userFilterDefaults[filterKey as keyof UserFilters]) return;

		const filter = {
			filterType: filterType,
			filterValue: filterValue,
		};

		searchFilters.push(filter);
	});

	return searchFilters;
};

export const createSavedHomeSearch = async (
	searchName: string,
	filters: UserFilters,
	frequency: frequency,
	userLocation: UserLocation,
) => {
	const searchFilters = getValidFilterItemsAndConvertToSearchFormat(filters);

	const dbFilterQuery = createQuery(userLocation, filters, 1000, 0, 1);

	const search = {
		searchName,
		filters: searchFilters,
		location: userLocation,
		dbFilterQuery,
		frequency,
		url: window.location.href,
	};

	const bodyInit: BodyInit = JSON.stringify(search);

	const requestOptions: RequestInit = {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
		},
		body: bodyInit,
	};

	const savedSearchAlertPostResponse = await fetchWithAuth(`${savedSearchApiUrl}v1/search`, requestOptions);

	if (!savedSearchAlertPostResponse.ok) {
		throw new Error(await savedSearchAlertPostResponse.json());
	}

	return true;
};
